import { StyleSheet, View } from 'react-native'
import { palette } from '../../../theme/palette'
import ArrowDown from './assets/ArrowDown.svg'

const Size = 30

export const Indicator = () => {
  return (
    <View style={[styles.position, styles.size, styles.view]}>
      <ArrowDown height="70%" width="70%" />
    </View>
  )
}

const styles = StyleSheet.create({
  position: {
    position: 'absolute',
    top: -Size - 5
  },
  size: {
    height: Size,
    width: Size
  },
  view: {
    backgroundColor: palette.orange,
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
})
